import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row d-flex justify-content-center" }
const _hoisted_2 = { class: "row d-flex justify-content-end mt-2" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Guardar")

import { AuthModule } from "@/store/modules/Auth";
import { TicketModule } from "@/store/modules/Ticket";
import { ref, watch } from "vue";
import { socket } from "@/main";
import { AlertModule } from "@/store/modules/Alert";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const comment = ref(TicketModule.comment);

watch(
	() => [TicketModule.comment],
	() => {
		comment.value = TicketModule.comment
	}
); 

const saveComment = () => {
	if(comment.value) {
		socket.emit('TICKET_UPDATE_COMMENT', { token: AuthModule.token, ticket: TicketModule.currentRoomID, comentario: comment.value });

		AlertModule.SOCKET_PUSH_NOTIFICATION({
			text: `Se ha actualizado el comentario del ticket`,
			type: "success",
		});
	} else 
		AlertModule.SOCKET_PUSH_NOTIFICATION({
			text: `Debe agregar un comentario`,
			type: "error",
		});
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_input, {
        type: "textarea",
        rows: 2,
        placeholder: "Escriba un comentario",
        modelValue: comment.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((comment).value = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        type: "default",
        onClick: saveComment,
        plain: ""
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})